/**
 * Formats a valid string into the date format:
 * `dd.mm.yyyy. hh:mm`.
 */
export default function formatFullDate(
	dateString: string | Date | number,
	showTime: boolean = true
) {
	const date = new Date(dateString)

	let ms = date.getTime()
	if (Number.isNaN(ms) || ms == 0) return ""

	const ensureAtleastTwoDigits = (num: number) => {
		let st = num.toString()
		return st.length == 1 ? `0${st}` : st
	}

	let minutes = ensureAtleastTwoDigits(date.getMinutes())
	let hours = ensureAtleastTwoDigits(date.getHours())
	let day = ensureAtleastTwoDigits(date.getDate())
	let month = ensureAtleastTwoDigits(date.getMonth() + 1)
	let year = ensureAtleastTwoDigits(date.getFullYear())

	return showTime ? `${day}/${month}/${year} ${hours}:${minutes}` : `${day}/${month}/${year}`
}
